export default "__VITE_PUBLIC_ASSET__0fa5f222__"